function handleHashChange() {
  const { hash } = window.location;

  switch (hash) {
    case '#settings':
      window.apm.reactDOMComponents.render({
        name: 'SettingWidget',
        props: { serialized: window.apm.serialized },
        $el: $('#settings')
      });
      break;
  }
}

window.addEventListener('hashchange', handleHashChange);
